import React, { useEffect, useState } from 'react';
import { environment } from '../../environment';
import axios from 'axios';

const AllTerminTable = () => {
  const getAllTerminsUrl = `${environment.LOCALHOST_URL}/termin/all-termins`;
  const [allTermins, setallTermins] = useState([]);

  useEffect(() => {
    axios
      .get(getAllTerminsUrl)
      .then((response) => {
        setallTermins(response.data.fullTermins);
        console.log(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [getAllTerminsUrl]);

  return (
    <div className='container'>
      <h1 style={{textAlign: 'center'}}>te gjitha terminet me te fundit</h1>
      <table className="table">
        <thead>
          <tr>
            <th scope="col">#</th>
            <th scope="col">Emri</th>
            <th scope="col">Tel</th>
            <th scope="col">Data</th>
            <th scope="col">Ora</th>
          </tr>
        </thead>
        <tbody>
            {
                allTermins.map((termin, i) => (
                    <tr key={i}>
                        <th scope="row"> {i+1} </th>
                        <td> {termin.client} </td>
                        <td> {termin.clientTel} </td>
                        <td> {termin.terminDate} </td>
                        <td> {termin.terminHour} </td>
                    </tr>

                ))
            }

        </tbody>
      </table>
    </div>
  );
};

export default AllTerminTable;
